import {
  TenantJob,
  SubTenantJob,
  TBMEmailImportData,
} from './../hooks/useSocketConnection';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TBMDeletedData } from '../hooks/useSocketConnection';

export type JobList = Record<string, TenantJob | SubTenantJob>;

export interface JobState {
  jobList: JobList;
}

const INITIAL_STATE: JobState = {
  jobList: {},
};

const { actions, reducer } = createSlice({
  name: "jobs",
  initialState: INITIAL_STATE,
  reducers: {
    setJobList: (state: JobState, action: PayloadAction<JobList>) => {
      state.jobList = action.payload;
    },
    updateJobList: (state: JobState, action: PayloadAction<JobList>) => {
      state.jobList = { ...state.jobList, ...action.payload };
      Object.values(state.jobList)
        .filter((value) => !value.job.isActive)
        ?.forEach((item) => {
          delete state.jobList[item.job.id];
        });
    },
    deleteJobList: (state: JobState) => {
      state.jobList = {};
    },
    updateJobState: (
      state: JobState,
      action: PayloadAction<TBMEmailImportData>
    ) => {
      const id = action.payload.jobId;
      if (
        action.payload.status === "SUCCESS" &&
        (!state.jobList[id].job.lastSuccess ||
          state.jobList[id].job.lastSuccess! <= action.payload.date)
      ) {
        state.jobList[id].job.lastSuccess = action.payload.date;
      }

      if (
        action.payload.status === "WARN" &&
        (!state.jobList[id].job.lastWarning ||
          state.jobList[id].job.lastWarning! <= action.payload.date)
      ) {
        state.jobList[id].job.lastWarning = action.payload.date;
      }
      if (
        !state.jobList[id].job.lastEmail ||
        state.jobList[id].job.lastEmail! <= action.payload.date
      ) {
        state.jobList[id].job.lastEmail = action.payload.date;
      }
    },
    deleteJobFromList: (
      state: JobState,
      action: PayloadAction<TBMDeletedData>
    ) => {
      const jobInfo = action.payload;
      if (jobInfo.job === 'ALL') {
        if (jobInfo.type === 'TENANT_BM_REMOVE') {
          for (const jobId in state.jobList) {
            if (state.jobList[jobId].tenantNumber === jobInfo.tenantNumber) delete state.jobList[jobId];
          }
        } else {
          for (const jobId in state.jobList) {
            const job = state.jobList[jobId];
            if (job.type === 'TENANT_SUB_BM' && job.tenantSubNumber === jobInfo.tenantSubId) delete state.jobList[jobId];
          }
        }
      } else {
        delete state.jobList[jobInfo.job.id];
      }
    },
  },
});

const getJobState = (state: any): JobState => state.jobs;

const getJobList = createSelector(
  getJobState,
  (jobs: JobState) => jobs.jobList
);

export const selectors = { getJobList };

export const { setJobList, updateJobList, updateJobState, deleteJobList, deleteJobFromList } =
  actions;

export default reducer;
